import './app/publicPath'

const Vue = window.Vue

Vue.component('BonusCustomerOverview', () => import('./app/Customer/BonusCustomer/Overview.vue'))
Vue.component('ItemPoints', () => import('./app/ReachablePoints/ItemPoints.vue'))
Vue.component('BasketPoints', () => import('./app/ReachablePoints/BasketPoints.vue'))
Vue.component('CampaignList', () => import('./app/Campaign/CampaignList.vue'))
Vue.component('GuestToCustomer', () => import('./app/Customer/Register/GuestToCustomer.vue'))
Vue.component('TvMerchantList', () => import('./app/Community/TvMerchantList.vue'))
Vue.component('BonusCommunityOptIn', () => import('./app/Community/CommunityOptIn.vue'))
Vue.component('BonusPointsExpiry', () => import('./app/Customer/Expiry/PointsExpiry.vue'))

import './app/main'
